import { userFacingError } from '../utils/userFacingError';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { AuthService } from '../services/authService';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';

export const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const validateEmail = (value: string): boolean => {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email.trim()) {
      setError('E-Mail ist erforderlich');
      return;
    }

    if (!validateEmail(email)) {
      setError('Ungültige E-Mail-Adresse');
      return;
    }

    setError(undefined);
    setIsLoading(true);

    try {
      await AuthService.requestPasswordReset(email.trim());
      setEmailSent(true);
      toast.success('Reset-Link angefordert.');
    } catch (submitError) {
      toast.error(userFacingError(submitError, 'Versand fehlgeschlagen'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h1 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Passwort vergessen
          </h1>
          <p className="mt-2 text-center text-sm text-gray-600">
            Gib deine E-Mail-Adresse ein, um einen Reset-Link zu erhalten.
          </p>
        </div>

        {emailSent ? (
          <div className="bg-green-50 border border-green-200 text-green-800 rounded-lg p-4 text-sm">
            Die Anfrage wurde angenommen. Bitte prüfe dein Postfach und den Spam-Ordner. Falls keine E-Mail ankommt, kontaktiere die Redaktion.
          </div>
        ) : (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <Input
              label="E-Mail-Adresse"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={error}
            />

            <Button type="submit" className="w-full" loading={isLoading} disabled={isLoading}>
              Reset-Link senden
            </Button>
          </form>
        )}

        <p className="text-center text-sm text-gray-600">
          <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500">
            Zurück zur Anmeldung
          </Link>
        </p>
      </div>
    </div>
  );
};
